export function setConfiguracion(state, configuracion) {
  state.configuracionVuex = configuracion;
}
